import React from "react";
import { siteConfig } from "../siteConfig";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display font-black text-lg mb-3" style={{ color: siteConfig.colors.dark }}>{title}</h2>
    <div className="text-gray-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

const PrivacyPolicyPage = () => (
  <>
    <section className="pt-32 pb-10" style={{ backgroundColor: siteConfig.colors.dark }}>
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <h1 className="font-display font-black text-white" style={{ fontSize: "clamp(1.75rem,4vw,2.75rem)" }}>Privacy Policy</h1>
        <p className="mt-2 text-white/50 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
      </div>
    </section>

    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <Section title="Introduction">
          <p>
            {siteConfig.businessName} ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard information when you visit our website or contact us for services.
          </p>
        </Section>

        <Section title="Information We Collect">
          <p>We may collect the following types of information:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Name, phone number, and email address when you submit a contact form</li>
            <li>Project details and preferences you share with us</li>
            <li>General usage data via analytics (pages visited, time on site)</li>
          </ul>
        </Section>

        <Section title="How We Use Your Information">
          <p>We use the information we collect to:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Respond to your inquiries and provide estimates</li>
            <li>Communicate about your project</li>
            <li>Send occasional updates or promotions (you can opt out at any time)</li>
            <li>Improve our website and services</li>
          </ul>
        </Section>

        <Section title="SMS / Text Message Consent">
          <p>
            By submitting your phone number, you consent to receive text messages from {siteConfig.businessName} regarding your inquiry. Message and data rates may apply. You may opt out at any time by replying STOP.
          </p>
        </Section>

        <Section title="Information Sharing">
          <p>
            We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. We may share information with trusted third-party service providers who assist us in operating our website or conducting our business, provided those parties agree to keep this information confidential.
          </p>
        </Section>

        <Section title="Cookies">
          <p>
            Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings.
          </p>
        </Section>

        <Section title="Your Rights">
          <p>
            You may request access to, correction of, or deletion of personal data we hold about you at any time by contacting us at{" "}
            <a href={`mailto:${siteConfig.email}`} style={{ color: siteConfig.colors.primary }} className="font-medium">{siteConfig.email}</a>.
          </p>
        </Section>

        <Section title="Contact Us">
          <p>
            If you have questions about this Privacy Policy, please contact us at{" "}
            <a href={`mailto:${siteConfig.email}`} style={{ color: siteConfig.colors.primary }} className="font-medium">{siteConfig.email}</a>{" "}
            or call us at{" "}
            <a href={siteConfig.phoneHref} style={{ color: siteConfig.colors.primary }} className="font-medium">{siteConfig.phone}</a>.
          </p>
        </Section>
      </div>
    </section>
  </>
);

export default PrivacyPolicyPage;
